<obg-accordion [expanded]="[expandedAccordion]" (toggleChange)="onToggleChange($event)">
	<obg-accordion-header key="terms">
		<span class="obg-m-sm-terms-and-conditions-accordion-title">{{
			"terms-and-conditions.title" | translate
		}}</span>
		<span [class]="accordionIconName"></span>
	</obg-accordion-header>
	<obg-accordion-content key="terms">
		<span [innerHtml]="content"></span>
	</obg-accordion-content>
</obg-accordion>
